module.exports = __webpack_public_path__ + "static/media/close_menu.9cd592a5.svg";